







import { Component, Prop, Vue } from 'vue-property-decorator';

export type DropzoneVariant = 'default' | 'block';
@Component({})
export default class FormHeader extends Vue {
  @Prop(String) label!: string;
}
